import axios from 'common/interceptor/app.interceptor';
import { findParamFromUrl, getFromSessionStorage, showServiceError } from 'common/utils/app.utils';
import environment from 'config/config';
import * as query from 'qs';

const getAccessToken = () => {
  const accessToken = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : '';
  return accessToken;
};

export const fetchContentsForRateCard = (params: any) => {
  return axios({
    method: 'GET',
    url: `${environment.pnqapiBaseUrl}fetch/rateCard?${query.stringify(params)}`,
    headers: {
      'Content-Type': 'application/json',
      accessToken: getAccessToken()
    },
    skipServiceType: true,
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};

export const downloadRecords = (params: any) => {
  return axios({
    method: 'GET',
    url: `${environment.pnqapiBaseUrl}download/rateCard`,
    params,
    headers: {
      'Content-Type': 'application/json',
      accessToken: getAccessToken()
    },
    skipServiceType: true,
    responseType: 'blob',
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};

export const fetchUserDetails = () => {
  return axios({
    method: 'post',
    url: environment.pnqapiBaseUrl + 'atb/validate/user',
    data: { accessToken: localStorage.getItem('accessToken'), partyId: findParamFromUrl('partyId') },
    headers: {
      'Content-Type': 'application/json'
    },
    skipServiceType: true,
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};
